import { DataBean } from "../DataBean";

export class BudgetStructure extends DataBean {

    public async getBudgetStructureList(arg: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getBudgetStructureList_Number", [arg]);
    }

}
